import styled from "styled-components";

export const Navigation = styled.ul`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    line-height: 1;

    ::-webkit-scrollbar {
        display: none;
    }
`;

export const TextContainer = styled.div`
    width: max-content;
`